import { render, staticRenderFns } from "./ki.vue?vue&type=template&id=f957ee08&"
import script from "./ki.vue?vue&type=script&lang=js&"
export * from "./ki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports